<template>
  <div class="notice-pop">
    <div class="notice-txt"><slot></slot></div>
    <div class="close iconfont icon-close" @click="hide"> </div>
  </div>
</template>

<script>
export default {
  name: 'sNotice',
  props: { },
  data(){
    return{
       
    }
  },
  methods:{
    hide(){
        this.$emit('hide')
      }
  },
}
</script>
<style scoped lang="scss">
  .notice-pop{
    background: #fff;
    border-radius: 3rem;
    height: 30rem;
    display: inline-flex;
    align-items: center;
    padding: 0 11rem;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    white-space: nowrap;
    // top: 60rem;
    top:50rem;
    z-index: 30;
    .close{
      margin-left: 11rem;
      cursor: pointer;
    }
  }

</style>